<template>
  <div>
    <transition name="fade">
      <div class="toast-overlay" v-if="show" @click="clicked()">
        <div class="message-box">
          <slot name="content"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { EVENT } from '@/constants/event'

export default {
  name: 'GSToast',
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clicked () {
      this.$emit(EVENT.CLICKED)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';
@import '../assets/scss/fade-transition';

.toast-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999;

  .message-box {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: $font-size-xs;
    color: #FFFFFF;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    padding: $base-size * 45;
    border-radius: $base-size * 6;
    background: rgba(0, 15, 25, 0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSToast.vue